import { render, staticRenderFns } from "./PointCreditTelecomError.vue?vue&type=template&id=3abac662"
import script from "./PointCreditTelecomError.vue?vue&type=script&lang=js"
export * from "./PointCreditTelecomError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports